import {
  useAppointableCategories,
  useAppointableCategoryCreate,
  useAppointableCategoryDisable,
  useMutationAppointableCategoryUpdate,
} from "@gymflow/api";
import { ManageModal } from "apps/portal/src/components/atoms";
import useGymflowModels from "apps/portal/src/store";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type AppointmentCategoriesModalProps = {
  onHide: () => void;
};

export const AppointmentCategoriesModal = ({
  onHide,
}: AppointmentCategoriesModalProps) => {
  const { t } = useTranslation();
  const { api } = useGymflowModels();

  const {
    data: appointableCategories,
    isLoading: isLoadingAppointableCategories,
  } = useAppointableCategories({
    api,
    paginationOption: {
      page: 0,
      size: 100,
    },
    filter: {
      statusList: ["ACTIVE"],
    },
  });

  const {
    mutateAsync: mutateAsyncCreateCategory,
    isPending: isPendingCreateCategory,
  } = useAppointableCategoryCreate({ api });
  const {
    mutateAsync: mutateAsyncUpdateCategory,
    isPending: isPendingUpdateCategory,
  } = useMutationAppointableCategoryUpdate({ api });

  const { mutateAsync: mutateAsyncDisableCategory } =
    useAppointableCategoryDisable({
      api,
    });

  const appointableCategoriesList = useMemo(
    () =>
      appointableCategories?.content.map((item) => ({
        id: item.id,
        name: item.name,
      })) ?? [],
    [appointableCategories],
  );

  return (
    <ManageModal
      toastMessage={t(
        "page.settings.tab.appointments.appointableWizard.appointableWizardDetailsForm.appointmentCategoriesModal.toastMessage",
      )}
      title={t(
        "page.settings.tab.appointments.appointableWizard.appointableWizardDetailsForm.appointmentCategoriesModal.title",
      )}
      description={t(
        "page.settings.tab.appointments.appointableWizard.appointableWizardDetailsForm.appointmentCategoriesModal.description",
      )}
      onHide={() => onHide()}
      items={appointableCategoriesList}
      isLoadingList={isLoadingAppointableCategories}
      isPendingAdd={isPendingCreateCategory}
      isPendingEdit={isPendingUpdateCategory}
      onAdd={async (name) => {
        await mutateAsyncCreateCategory({
          name,
          color: "#ffffff",
        });
      }}
      onEdit={async (id, name) => {
        await mutateAsyncUpdateCategory({
          id,
          params: { name },
        });
      }}
      onDeleteItem={async ({ id }) => {
        await mutateAsyncDisableCategory(id);
      }}
    />
  );
};
